import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const upsert = (selector, create) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = create();
    document.head.appendChild(element);
  }

  return element;
};

export default function Canonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';
    const url = `${window.location.origin}${path}`;

    upsert('link[rel="canonical"]', () => {
      const link = document.createElement('link');
      link.rel = 'canonical';
      return link;
    }).href = url;

    upsert('meta[property="og:url"]', () => {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      return meta;
    }).content = url;
  }, [pathname]);

  return null;
}
